import toast from "react-hot-toast";
import {
  PROMOTED_LINK_WARNING,
  revealPromotedLinkPlaceholder,
} from "./promoted-link";

/**
 * Raises the unreplaced-placeholder warning as a toast that jumps to the
 * placeholder when clicked.
 *
 * Without this the reader has to scan the whole article to find the one link
 * still pointing at the placeholder. The toast body is a button so it is
 * reachable by keyboard as well as by pointer.
 */
const showPromotedLinkWarning = (): void => {
  toast.error(
    (t) => (
      <button
        type="button"
        onClick={() => {
          if (revealPromotedLinkPlaceholder()) {
            toast.dismiss(t.id);
          }
        }}
        style={{
          background: "none",
          border: "none",
          padding: 0,
          margin: 0,
          font: "inherit",
          color: "inherit",
          textAlign: "left",
          cursor: "pointer",
        }}
      >
        {PROMOTED_LINK_WARNING} Click to jump to it.
      </button>
    ),
    { duration: 8000 },
  );
};

export { showPromotedLinkWarning };
